import React from 'react'
import { CancelIcon } from '@mote/assets/icons'
import type { CommonButtonProps } from './Common'
import { CommonButton } from './Common'

export interface CancelButtonProps extends Pick<CommonButtonProps, 'onClick'> {}

export function CancelButton(props: CancelButtonProps): JSX.Element {
  return (
    <CommonButton
      id={'cancel-button'}
      text={'Cancel'}
      variant={'warning'}
      onClick={props.onClick}
      ariaLabel={'cancel'}
    >
      <CancelIcon />
    </CommonButton>
  )
}
